module.exports = __webpack_public_path__ + "static/media/cbs.bc90702e.JPG";